import { Link } from 'react-router-dom';

const channels = [
  { label: '国漫频道', to: '/guoman' },
  { label: '日漫频道', to: '/riman' },
  { label: '人气榜单', to: '/top' },
  { label: '关于我们', to: '/about' },
];

const categories = ['玄幻', '武侠', '古风', '都市', '科幻', '悬疑', '热血', '恋爱', '治愈', '美食', '搞笑', '冒险'];

export default function Footer() {
  return (
    <footer className="mt-16 bg-foreground-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-bug-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">
                虫虫<span className="text-accent-400">漫画</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/90">
              虫虫漫画网专注国漫与日漫分类整理，按题材、类型快速查找你喜欢的作品。热门连载与经典作品一站收录，点开就能按分类逛，不用再到处搜。
            </p>
            <div className="mt-5 flex items-center gap-3 text-sm text-background-300">
              <a href="mailto:support@chongchong-manga.com" className="inline-flex items-center gap-1.5 hover:text-accent-400 transition-colors">
                <i className="ri-mail-line"></i>support@chongchong-manga.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">网站导航</h4>
            <ul className="mt-4 space-y-2.5">
              {channels.map((c) => (
                <li key={c.to}>
                  <Link to={c.to} className="text-sm text-background-200/90 hover:text-accent-400 transition-colors">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg text-background-50">热门题材</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {categories.slice(0, 8).map((c) => (
                <li key={c}>
                  <Link
                    to="/guoman"
                    className="inline-block whitespace-nowrap rounded-full border border-background-100/15 px-3 py-1 text-xs text-background-200/90 hover:border-accent-400 hover:text-accent-400 transition-colors"
                  >
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-100/10 pt-6 text-xs text-background-300 sm:flex-row">
          <p>虫虫漫画 · 国漫日漫分类大全，想看的漫画这里都有</p>
          <p>本站内容仅供分类索引参考，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}